import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
const fadeUp = function (items, trigger) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const elements = Array.from(items).filter(Boolean);
  if (!elements.length || !trigger) return;

  // Beginstand wordt via CSS gezet in _animations.scss
  gsap.to(elements, {
    opacity: 1,
    y: 0,
    duration: options.duration || 0.75,
    stagger: options.stagger || 0.12,
    ease: options.ease || 'power2.out',
    scrollTrigger: {
      trigger,
      start: options.start || 'top 85%',
      once: true
    }
  });
};
export function initHeaderAnimations() {
  const header = document.querySelector('[data-component="header"]');
  if (!header) return;
  const logo = header.querySelector('.header__left');
  const menuLinks = header.querySelectorAll('.header__right > .header__menu .header__menu-link');
  const button = header.querySelector('.header__right > .button');
  const shapes = header.querySelector('.header__shapes');
  menuLinks.forEach(link => {
    if (link.dataset.split === 'true') return;
    const badge = link.querySelector('span');
    const text = Array.from(link.childNodes).find(node => {
      return node.nodeType === Node.TEXT_NODE && node.textContent.trim().length;
    });
    if (!text) return;
    const wrapper = document.createElement('em');
    wrapper.classList.add('header__menu-text');
    wrapper.style.display = 'inline-flex';
    wrapper.style.overflow = 'hidden';
    wrapper.style.fontStyle = 'normal';
    wrapper.innerHTML = text.textContent.trim().split('').map(letter => {
      const value = letter === ' ' ? '&nbsp;' : letter;
      return `<i class="header__menu-letter" style="display:inline-block; font-style:normal;">${value}</i>`;
    }).join('');
    text.replaceWith(wrapper);
    if (badge) {
      link.appendChild(badge);
    }
    link.dataset.split = 'true';
  });
  const letters = Array.from(header.querySelectorAll('.header__right .header__menu-letter'));
  gsap.set(letters, {
    opacity: 0,
    y: 50
  });
  const tl = gsap.timeline({
    delay: 0.3,
    defaults: {
      ease: 'expo.out'
    }
  });
  tl.to(logo, {
    y: 0,
    opacity: 1,
    duration: 0.8
  }).to(letters, {
    y: 0,
    opacity: 1,
    duration: 0.65,
    stagger: {
      each: 0.012,
      from: 'start'
    }
  }, '-=0.7');

  // Sla het absolute starttijdstip van de letters op en animeer elke badge
  // op het moment dat de eerste letter van datzelfde menu-item begint.
  const lettersStart = tl.recent().startTime();
  tl.to(button, {
    y: 0,
    opacity: 1,
    duration: 0.7
  }, '-=0.65').to(shapes, {
    y: 0,
    opacity: 1,
    duration: 0.7
  }, '<');
  menuLinks.forEach(link => {
    const badge = link.querySelector('span');
    if (!badge) return;
    const linkLetters = link.querySelectorAll('.header__menu-letter');
    if (!linkLetters.length) return;
    const firstLetterIndex = letters.indexOf(linkLetters[0]);
    if (firstLetterIndex === -1) return;
    const lastLetterIndex = firstLetterIndex + linkLetters.length - 1;
    const letterDuration = 0.65;
    tl.to(badge, {
      opacity: 1,
      duration: 0.5,
      ease: 'power2.out'
    }, lettersStart + lastLetterIndex * 0.012 + letterDuration);
  });
}
export function initHeroAnimations() {
  const hero = document.querySelector('[data-component="hero"]');
  if (!hero) return;
  const reveal = hero.querySelector('.hero__reveal');
  const title = hero.querySelector('.hero__content h1');
  const buttons = hero.querySelectorAll('.hero__content .button');
  const uspItems = hero.querySelectorAll('.hero__usp .swiper-slide');

  // Beginstand via CSS in hero.scss en _animations.scss
  const tl = gsap.timeline();
  if (reveal) {
    tl.to(reveal, {
      clipPath: 'inset(0% 0% 0% 0%)',
      webkitClipPath: 'inset(0% 0% 0% 0%)',
      duration: 1.4,
      ease: 'power4.out',
      delay: 0.25
    });
  }
  tl.to(title, {
    y: 0,
    opacity: 1,
    duration: 0.9,
    ease: 'expo.out'
  }, '-=0.85').to(buttons, {
    y: 0,
    opacity: 1,
    duration: 0.8,
    stagger: 0.12,
    ease: 'expo.out'
  }, '-=0.55').to(uspItems, {
    y: 0,
    opacity: 1,
    duration: 0.6,
    stagger: 0.14,
    ease: 'power3.out'
  }, '<');
}
export function initIntroBlockAnimations() {
  const blocks = document.querySelectorAll('[data-component="intro-block"]');
  if (!blocks.length) return;
  blocks.forEach(block => {
    const content = block.querySelector('.intro-block__left');
    const buttons = block.querySelectorAll('.intro-block__buttons .button');
    const uspItems = block.querySelectorAll('.intro-block__usp li');

    // Beginstand via CSS in _animations.scss
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: block,
        start: 'top 75%',
        once: true
      }
    });
    tl.to(content, {
      clipPath: 'inset(0% 0% 0% 0%)',
      webkitClipPath: 'inset(0% 0% 0% 0%)',
      duration: 1.4,
      ease: 'power4.out'
    }).to(buttons, {
      opacity: 1,
      duration: 0.8,
      stagger: 0.12,
      ease: 'power2.out'
    }, '-=0.4').to(uspItems, {
      y: 0,
      opacity: 1,
      duration: 0.8,
      stagger: 0.2,
      ease: 'expo.out'
    }, '-=0.7');
  });
}
export function initTitleAnimations() {
  const titles = document.querySelectorAll('h1, h2, h3, h4, h5, h6');
  if (!titles.length) return;
  titles.forEach(title => {
    if (title.closest('[data-component="hero"]')) return;
    if (title.closest('[data-component="intro-block"]')) return;
    if (title.closest('.content-kennis-detail')) return;
    if (title.closest('[data-component="footer"]')) return;
    if (title.dataset.titleAnimated === 'true') return;
    const titleHighlight = title.querySelector('span');
    let titleRest = null;
    if (titleHighlight) {
      const restText = Array.from(title.childNodes).find(node => {
        return node.nodeType === Node.TEXT_NODE && node.textContent.trim().length;
      });
      if (restText) {
        titleRest = document.createElement('strong');
        titleRest.classList.add('title-animation-rest');
        titleRest.textContent = restText.textContent.trim();
        titleRest.style.display = 'block';
        titleRest.style.fontWeight = 'inherit';
        titleRest.style.color = 'inherit';
        restText.replaceWith(titleRest);
      }
    }

    // Als er een span is, animeer die (en eventueel titleRest) apart.
    // Als er geen span is, animeer de volledige heading en markeer via CSS-klasse.
    let items;
    if (titleHighlight) {
      items = titleRest ? [titleHighlight, titleRest] : [titleHighlight];
    } else {
      title.classList.add('will-animate-title');
      items = [title];
    }
    gsap.to(items, {
      y: 0,
      opacity: 1,
      duration: 0.9,
      stagger: 0.16,
      ease: 'expo.out',
      scrollTrigger: {
        trigger: title,
        start: 'top 90%',
        once: true
      }
    });
    title.dataset.titleAnimated = 'true';
  });
}
export function initTextAnimations() {
  // Breadcrumbs container als geheel infaden (niet de individuele tekst)
  document.querySelectorAll('.breadcrumbs').forEach(breadcrumb => {
    fadeUp([breadcrumb], breadcrumb, {
      y: 12,
      duration: 0.7,
      start: 'top 95%',
      ease: 'power2.out'
    });
  });
  const blocks = document.querySelectorAll('[data-component]');
  if (!blocks.length) return;
  const excludedComponents = new Set(['hero', 'header', 'intro-block', 'team', 'footer', 'breadcrumbs']);
  blocks.forEach(block => {
    if (block.classList.contains('content-kennis-detail')) return;
    if (excludedComponents.has(block.dataset.component)) return;
    const items = Array.from(block.querySelectorAll('p, li, address')).filter(item => !item.closest('.breadcrumbs') && !item.closest('.footer__link') && !item.querySelector('p, li, address'));
    items.forEach(item => {
      fadeUp([item], item, {
        y: 18,
        duration: 0.75,
        start: 'top 90%',
        ease: 'power2.out'
      });
    });

    // Buttons apart
    const buttons = Array.from(block.querySelectorAll('.button'));
    buttons.forEach(button => {
      gsap.to(button, {
        y: 0,
        opacity: 1,
        duration: 0.75,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: button,
          start: 'top 90%',
          once: true
        }
      });
    });
  });
}
export function initFooterAnimations() {
  const footer = document.querySelector('[data-component="footer"]');
  if (!footer) return;
  const cta = footer.querySelector('.footer__cta');
  const ctaLeft = footer.querySelector('.footer__cta-left');
  if (cta && ctaLeft) {
    // Beginstand via CSS custom properties in footer.scss (--footer-shape-y: 100%, --footer-shape-opacity: 0)
    gsap.to(ctaLeft, {
      '--footer-shape-y': '0%',
      '--footer-shape-opacity': 1,
      duration: 1.4,
      ease: 'expo.out',
      scrollTrigger: {
        trigger: cta,
        start: 'top 90%',
        once: true
      }
    });
  }
  const footerLinks = footer.querySelectorAll('.footer__menu-secondary a, .footer__socials a');
  footerLinks.forEach(link => {
    fadeUp([link], link, {
      y: 18,
      duration: 1.4,
      stagger: 0,
      start: 'top 92%',
      ease: 'power2.out'
    });
  });
}
export function initTeamAnimations() {
  const teams = document.querySelectorAll('[data-component="team"]');
  if (!teams.length) return;
  teams.forEach(team => {
    const rows = {};
    const slides = Array.from(team.querySelectorAll('.team__slide'));
    if (!slides.length) return;
    slides.forEach(slide => {
      const top = Math.round(slide.offsetTop);
      if (!rows[top]) {
        rows[top] = [];
      }
      rows[top].push(slide);
    });
    Object.values(rows).forEach(row => {
      fadeUp(row, row[0], {
        y: 12,
        duration: 1.4,
        stagger: 0.16,
        start: 'top 65%',
        ease: 'power2.out'
      });
    });
  });
}
export function initKennisDetailContent() {
  const content = document.querySelector('.content__left_text');
  if (!content) return;
  gsap.from(content, {
    opacity: 0,
    y: 18,
    duration: 0.75,
    ease: 'power2.out',
    scrollTrigger: {
      trigger: content,
      start: 'top 65%',
      once: true
    }
  });
}
export default function initAnimations() {
  initHeaderAnimations();
  initHeroAnimations();
  initIntroBlockAnimations();
  initTitleAnimations();
  initTextAnimations();
  initFooterAnimations();
  initTeamAnimations();
  initKennisDetailContent();
  ScrollTrigger.refresh();

  // Refresh na volledig laden — herstelt ScrollTrigger-posities na layout-shifts door afbeeldingen
  window.addEventListener('load', () => ScrollTrigger.refresh());
}